/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type LotCurrency = "CHF" | "EUR" | "GBP";
export type UpsertDevelopmentRegistrationFormInput = {|
  developmentRegistrationForm?: ?DevelopmentRegistrationFormInput,
  clientMutationId?: ?string,
|};
export type DevelopmentRegistrationFormInput = {|
  id?: ?string,
  productId?: ?string,
  developmentProductId?: ?string,
  firstBuyerFirstName?: ?string,
  firstBuyerLastName?: ?string,
  firstBuyerEmailAddress?: ?string,
  firstBuyerPhoneNumber?: ?string,
  emailAddress?: ?string,
  phoneNumber?: ?string,
  numberOfBuyers?: ?number,
  isAlreadyOwner?: ?boolean,
  inviteSecondBuyer?: ?boolean,
  firstBuyerDateOfBirth?: ?string,
  firstBuyerOccupationId?: ?string,
  firstBuyerNationalityId?: ?string,
  firstBuyerWorkPermitId?: ?string,
  firstBuyerAnnualRevenues?: ?number,
  firstBuyerSavings?: ?number,
  firstBuyerUseOfSecondPillar?: ?boolean,
  firstBuyerSecondPillar?: ?number,
  firstBuyerUseOfThirdPillar?: ?boolean,
  firstBuyerThirdPillar?: ?number,
  secondBuyerFirstName?: ?string,
  secondBuyerLastName?: ?string,
  secondBuyerEmailAddress?: ?string,
  secondBuyerPhoneNumber?: ?string,
  secondBuyerDateOfBirth?: ?string,
  secondBuyerOccupationId?: ?string,
  secondBuyerNationalityId?: ?string,
  secondBuyerWorkPermitId?: ?string,
  secondBuyerAnnualRevenues?: ?number,
  secondBuyerSavings?: ?number,
  secondBuyerUseOfSecondPillar?: ?boolean,
  secondBuyerSecondPillar?: ?number,
  secondBuyerUseOfThirdPillar?: ?boolean,
  secondBuyerThirdPillar?: ?number,
  maximumBudget?: ?number,
  buyApartment?: ?boolean,
  buyHouse?: ?boolean,
  minNumberOfBedrooms?: ?number,
  buyGroundFloor?: ?boolean,
  buyIntermediateFloor?: ?boolean,
  buyTopFloor?: ?boolean,
  hasLandForSale?: ?boolean,
  step?: ?DevelopmentRegistrationStep,
|};
export type DevelopmentFirstBuyerStepUpsertFormMutationVariables = {|
  input: UpsertDevelopmentRegistrationFormInput
|};
export type DevelopmentFirstBuyerStepUpsertFormMutationResponse = {|
  +upsertDevelopmentRegistrationForm: ?{|
    +form: ?{|
      +id: string,
      +completed: boolean,
      +phoneNumber: ?string,
      +firstBuyerNationality: ?{|
        +id: string,
        +label: string,
        +name: string,
      |},
      +firstBuyerOccupation: ?{|
        +id: string,
        +label: string,
      |},
      +firstBuyerWorkPermit: ?{|
        +id: string,
        +label: string,
      |},
      +firstBuyerFirstName: ?string,
      +firstBuyerLastName: ?string,
      +firstBuyerDateOfBirth: ?string,
      +firstBuyerEmailAddress: ?string,
      +firstBuyerPhoneNumber: ?string,
      +firstBuyerAnnualRevenues: ?number,
      +firstBuyerSavings: ?number,
      +numberOfBuyers: ?number,
      +isAlreadyOwner: ?boolean,
      +secondBuyerFirstName: ?string,
      +secondBuyerLastName: ?string,
      +step: ?DevelopmentRegistrationStep,
      +product: ?{|
        +id: string
      |},
      +developmentProduct: ?{|
        +id: string,
        +products: $ReadOnlyArray<{|
          +id: string,
          +lotReference: ?string,
          +currency: ?LotCurrency,
          +salePrice: ?number,
          +status: string,
          +property: {|
            +id: string,
            +numberOfRooms: ?number,
            +floorOfFlat: ?number,
            +numberOfFloors: ?number,
          |},
        |}>,
      |},
    |}
  |}
|};
export type DevelopmentFirstBuyerStepUpsertFormMutation = {|
  variables: DevelopmentFirstBuyerStepUpsertFormMutationVariables,
  response: DevelopmentFirstBuyerStepUpsertFormMutationResponse,
|};
*/


/*
mutation DevelopmentFirstBuyerStepUpsertFormMutation(
  $input: UpsertDevelopmentRegistrationFormInput!
) {
  upsertDevelopmentRegistrationForm(input: $input) {
    form: developmentRegistrationForm {
      id
      completed
      phoneNumber
      firstBuyerNationality {
        id
        label
        name
      }
      firstBuyerOccupation {
        id
        label
      }
      firstBuyerWorkPermit {
        id
        label
      }
      firstBuyerFirstName
      firstBuyerLastName
      firstBuyerDateOfBirth
      firstBuyerEmailAddress
      firstBuyerPhoneNumber
      firstBuyerAnnualRevenues
      firstBuyerSavings
      numberOfBuyers
      isAlreadyOwner
      secondBuyerFirstName
      secondBuyerLastName
      step
      product {
        id
      }
      developmentProduct {
        id
        products {
          id
          lotReference
          currency
          salePrice
          status
          property {
            id
            numberOfRooms
            floorOfFlat
            numberOfFloors
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertDevelopmentRegistrationFormPayload",
    "kind": "LinkedField",
    "name": "upsertDevelopmentRegistrationForm",
    "plural": false,
    "selections": [
      {
        "alias": "form",
        "args": null,
        "concreteType": "DevelopmentRegistrationForm",
        "kind": "LinkedField",
        "name": "developmentRegistrationForm",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "firstBuyerNationality",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "firstBuyerOccupation",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "firstBuyerWorkPermit",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerDateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerEmailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerAnnualRevenues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBuyerSavings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfBuyers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAlreadyOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "step",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentProduct",
            "kind": "LinkedField",
            "name": "developmentProduct",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "products",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lotReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfRooms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "floorOfFlat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfFloors",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevelopmentFirstBuyerStepUpsertFormMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevelopmentFirstBuyerStepUpsertFormMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "961743b7e6a515d619422d9ada5e537b",
    "id": null,
    "metadata": {},
    "name": "DevelopmentFirstBuyerStepUpsertFormMutation",
    "operationKind": "mutation",
    "text": "mutation DevelopmentFirstBuyerStepUpsertFormMutation(\n  $input: UpsertDevelopmentRegistrationFormInput!\n) {\n  upsertDevelopmentRegistrationForm(input: $input) {\n    form: developmentRegistrationForm {\n      id\n      completed\n      phoneNumber\n      firstBuyerNationality {\n        id\n        label\n        name\n      }\n      firstBuyerOccupation {\n        id\n        label\n      }\n      firstBuyerWorkPermit {\n        id\n        label\n      }\n      firstBuyerFirstName\n      firstBuyerLastName\n      firstBuyerDateOfBirth\n      firstBuyerEmailAddress\n      firstBuyerPhoneNumber\n      firstBuyerAnnualRevenues\n      firstBuyerSavings\n      numberOfBuyers\n      isAlreadyOwner\n      secondBuyerFirstName\n      secondBuyerLastName\n      step\n      product {\n        id\n      }\n      developmentProduct {\n        id\n        products {\n          id\n          lotReference\n          currency\n          salePrice\n          status\n          property {\n            id\n            numberOfRooms\n            floorOfFlat\n            numberOfFloors\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '935bbb5f138780d494a9f937210b96fb';

export default node;
